import { render, staticRenderFns } from "./DeleteShirtModal.vue?vue&type=template&id=6887a130"
import script from "./DeleteShirtModal.vue?vue&type=script&lang=js"
export * from "./DeleteShirtModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports